import { CountryRepository } from '@/core/domain/countries/repositories/country.repository';
import { GetCountriesUseCase } from '@/core/domain/countries/usecases/get-countries.usecase';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CountryImplRepository } from './country-impl.repository';

const getCountriesUseCaseFactory = (countriesRepository: CountryRepository) =>
    new GetCountriesUseCase(countriesRepository);

@NgModule({
    imports: [CommonModule],
    providers: [
        {
            provide: GetCountriesUseCase,
            useFactory: getCountriesUseCaseFactory,
            deps: [CountryRepository],
        },
        {
            provide: CountryRepository,
            useClass: CountryImplRepository,
        },
    ],
})
export class CountryDataModule {}
